import React from "react"
import clsx from "clsx"
import { FaCheck } from "react-icons/fa"

import classes from "./RadioButton.module.scss"

const RadioButton = props => {
  const {
    className = "",
    color = "primary",
    checked = false,
    disabled = false,
    onChange = () => { },
    ...otherProps
  } = props

  return (
    <div
      className={clsx(classes["checkbox-container"], className)}
      onClick={e => !disabled && onChange(!checked, e)}
      {...otherProps}
    >
      <input
        className={classes["hidden-checkbox"]}
      />
      <div
        className={clsx(classes["checkbox"],
          checked && classes["checkbox-checked"],
          checked && classes[color],
          disabled && classes["checkbox-disabled"],
          checked && disabled && classes["checkbox-checked-disabled"]
        )}
      >
        {
          checked &&
          <FaCheck className={classes["check"]} />
        }
      </div>
    </div>
  )
}

export default RadioButton